import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CheckoutSummaryVM } from '../../../types/donation-flow.models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'don-checkout-summary',
    imports: [CommonModule, TranslateModule],
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutSummaryComponent {
  /** Un SOLO objeto de entrada con todo lo necesario para renderizar */
  @Input({ required: true }) vm!: CheckoutSummaryVM;

  /** Translation key for the heading; overridable when embedded as a full step (vs. the fee-review modal). */
  @Input() titleKey = 'CAMPAIGN.Summary';

  /** Emite el vm actualizado (p.ej., cuando cambia feesCovered) */
  @Output() vmChange = new EventEmitter<CheckoutSummaryVM>();

  // Getters derivados (sin estado interno)
  get crezcoReceives(): number {
    if (!this.vm?.hasCalculatedFees || this.vm.donationFees === undefined) return 0;
    return this.vm.feesCovered
      ? this.vm.donationAmount
      : Math.max(this.vm.donationAmount - this.vm.donationFees, 0);
  }

  get donationTotal(): number {
    if (!this.vm?.hasCalculatedFees || this.vm.donationFees === undefined) return 0;
    return this.vm.feesCovered
      ? this.vm.donationAmount + this.vm.donationFees
      : this.vm.donationAmount;
  }

  onToggleCoverFees(isChecked: boolean) {
    // Emitimos el objeto completo actualizado
    this.vmChange.emit({ ...this.vm, feesCovered: isChecked });
  }
}
